import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';

export const SHOP_FEATURE = 'shop';
export const SHOPS_LIST = '[Shop] Shop List';

export interface StateWithShop {
  [SHOP_FEATURE]: ShopState;
}

export interface ShopState {
  shops: StateUtils.LoaderState<Pos[]>;
}
